module.exports = __webpack_public_path__ + "static/media/customizacion.3cd2a2d6.png";